import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { take, tap } from 'rxjs/operators';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Activity } from '@vendasta/automata';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { EndAutomationRunDialogComponent } from '../end-automation-run/end-automation-run-dialog.component';
import { STANDARD_DIALOG_WIDTH } from '@galaxy/automata/shared';

export interface ActivityRow {
  activity: Activity;
}

@Component({
  template: `
    <div class="cell-container">
      <button mat-stroked-button (click)="endRun()" [disabled]="!!endRequested">
        {{ 'AUTOMATIONS.END_RUN.END_RUN' | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      .cell-container {
        text-align: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatButtonModule, MatDialogModule],
})
export class EndRunCellComponent implements CustomCellComponent<ActivityRow>, OnInit {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: ActivityRow;
  @Input() eventEmitter: EventEmitter<any>;

  loading = false;

  endRequested: boolean;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.endRequested = this.element.activity.endRunRequested && !this.element.activity.completedProcessing;
  }

  endRun(): void {
    const dialog = this.dialog.open(EndAutomationRunDialogComponent, {
      width: STANDARD_DIALOG_WIDTH,
      data: {
        automationId: this.element.activity.automationId,
        mainRunId: this.element.activity.mainRunId,
        entityId: this.element.activity.entityId,
        workflowStepId: this.element.activity.workflowStep.id,
        stepExecutionUUID: this.element.activity.stepExecutionUuid,
      },
    });
    dialog
      .afterClosed()
      .pipe(
        take(1),
        tap((endRequested) => {
          this.endRequested = endRequested;
          this.cdr.detectChanges();
        }),
      )
      .subscribe();
  }
}
